import React from "react";
import { Box, Typography } from "@mui/material";

import SortArrow from "../SortArrow";
import { TBy } from "../../../reducers/customers";
import { ISortBy } from "../../../types";

interface IProps {
  newSortBy(arg0: string): void;
  sortBy: ISortBy;
  by: string;
  isReset?: boolean;
  title: string;
  titleComponent?: React.ReactElement;
}

const TableDataCellWithSort = ({
  sortBy,
  newSortBy,
  by,
  isReset,
  title,
  titleComponent,
}: IProps): React.ReactElement => {
  const handleClick = (e: React.MouseEvent) => {
    const value: TBy = (e.currentTarget as HTMLButtonElement).getAttribute("data-sort") as TBy;
    newSortBy(value);
  };

  return (
    <Box
      component="td"
      sx={{
        cursor: "default",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#71b9e9 !important",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        onClick={handleClick}
        data-sort={by}
        role="button"
        tabIndex={-1}
      >
        {isReset && (
          <Typography
            sx={{
              color: "#fff",
              marginRight: 5,
              "&:hover": {
                cursor: "pointer",
                backgroundColor: "#3a94db",
              },
            }}
            onClick={handleClick}
            data-sort={by}
            role="button"
            tabIndex={-1}
          >
            R
          </Typography>
        )}

        <Box display="flex">
          <Typography
            fontWeight={800}
            color="#fff"
            mr="5px"
            whiteSpace="nowrap"
            sx={{ "&:hover": { cursor: "pointer" } }}
          >
            {titleComponent || title}
          </Typography>
          <SortArrow sortBy={sortBy} by={by} />
        </Box>
      </Box>
    </Box>
  );
};

export default TableDataCellWithSort;
